export default __webpack_public_path__ + "static/media/Detail-The-Deeds-of-Antichrist-Luca-Signorelli-1505.eda09a86.jpg";